import React from 'react';
import { Modal } from 'react-bootstrap';
import './login_required_modal.component.css';

const LoginRequiredModal = (props) => {
  return (
    <Modal
      show={props.isVisible}
      centered
      onHide={() => props.setIsVisible(false)}
      className="signup-free"
    >
      <Modal.Body className="text-center px-0">
        <div className="head">Login Required</div>
        <p className="info mb-0 mt-3">
          You need to be signed in to access this feature
        </p>
        <button
          className="signup-btn"
          onClick={() =>
            (window.location.href = window.location.origin + '/account/signup')
          }
        >
          SIGN UP FOR A FREE ACCOUNT
        </button>
        <div className="sign-in">
          Already have an account?{' '}
          <a href="/account/signin" className="sign-in-link">
            Sign In
          </a>
        </div>
      </Modal.Body>
      <div className="close-btn" onClick={() => props.setIsVisible(false)}>
        &#10006;
      </div>
    </Modal>
  );
};

export default LoginRequiredModal;
